import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { NotificationManager } from 'react-notifications';
import HOCLoader from '../../components/HOC/HOCLoader';
import { withTheme } from '@material-ui/core/styles';
import ContentLoader from 'react-content-loader';
import ProgressiveImage from 'react-progressive-image';
import { FormattedMessage, injectIntl } from 'react-intl';
import AppLinks from '../../components/About/AppLinks';

import about from 'assets/images/about.jpg';

class Detail extends Component {
    state = { data: '', loader: true };
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.getCmsDetailAction(
            { slug: this.props.match.params.slug },
            this.onDone
        );
    };
    componentDidUpdate(prevProps) {
        if (prevProps.match.params.slug != this.props.match.params.slug) {
            this.getData();
        }
    }
    onDone = (success, data) => {
        if (success) {
            document.title = data.data.meta_title;
            document.keywords = data.data.meta_keywords;
            document.description = data.data.meta_description;
            this.setState({ data: data.data, loader: false });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="pageNotFound"
                    defaultMessage="Page not found"
                />,
                'Error'
            );
        }
    };
    componentWillUnmount() {
        document.title = '';
        document.keywords = '';
        document.description = '';
    }
    renderLoading = index => {
        return (
            <div style={{ width: 800, height: 500 }} key={index}>
                <ContentLoader
                    width={800}
                    height={500}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect
                        x="100"
                        y="20"
                        rx="0"
                        ry="0"
                        width="200"
                        height="50"
                    />
                </ContentLoader>
            </div>
        );
    };

    render() {
        const { data, loader } = this.state;
        const banners = this.props.settings
            ? (this.props.settings || {}).banners || []
            : null;
        console.log({ banners });
        return (
            <HOCLoader loading={loader}>
                <div style={{ minHeight: 400 }}>
                    <div />
                    <div>
                        {data.slug == 'about-us' ? (
                            <div>
                                {data.title && (
                                    <div>
                                        <div
                                            className="inn-page-bg"
                                            style={{
                                                width: '100%',
                                                backgroundSize: 'cover',
                                                backgroundImage: `url(${
                                                    banners
                                                        ? (
                                                              (banners[0] || {})
                                                                  .image || {}
                                                          ).large
                                                        : null
                                                })`
                                            }}
                                        >
                                            <div className="container">
                                                <div className="row">
                                                    <div className="inn-pag-ban">
                                                        <h2>About Us</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="p-about com-padd">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="page-about pad-bot-red-40">
                                                            <h3>Welcome!</h3>{' '}
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        data.description
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="page-about">
                                                            {' '}
                                                            <img
                                                                src={about}
                                                                alt="about"
                                                            />{' '}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div class="p-about-count">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-md-2 col-sm-2 page-about-count">
                                                        <div>
                                                            {' '}
                                                            <span>48</span>
                                                            <h4>Countries</h4>
                                                            <p>
                                                                Local directory
                                                                is the smartest
                                                                way to find the
                                                                best services
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-sm-2 page-about-count">
                                                        <div>
                                                            {' '}
                                                            <span>3k</span>
                                                            <h4>cities</h4>
                                                            <p>
                                                                Local directory
                                                                is the smartest
                                                                way to find the
                                                                best services
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-sm-2 page-about-count">
                                                        <div>
                                                            {' '}
                                                            <span>5k</span>
                                                            <h4>Business</h4>
                                                            <p>
                                                                Local directory
                                                                is the smartest
                                                                way to find the
                                                                best services
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-sm-2 page-about-count">
                                                        <div>
                                                            {' '}
                                                            <span>6k</span>
                                                            <h4>Users</h4>
                                                            <p>
                                                                Local directory
                                                                is the smartest
                                                                way to find the
                                                                best services
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-sm-2 page-about-count">
                                                        <div>
                                                            {' '}
                                                            <span>20k</span>
                                                            <h4>Reviews</h4>
                                                            <p>
                                                                Local directory
                                                                is the smartest
                                                                way to find the
                                                                best services
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-sm-2 page-about-count page-about-count-no-bor">
                                                        <div>
                                                            {' '}
                                                            <span>50k</span>
                                                            <h4>Visiters</h4>
                                                            <p>
                                                                Local directory
                                                                is the smartest
                                                                way to find the
                                                                best services
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="text-center">
                                {data.title && (
                                    <div>
                                        <div
                                            className="inn-page-bg"
                                            style={{
                                                width: "100%",
                                                backgroundSize: 'cover',
                                                backgroundImage: `url(${
                                                    banners
                                                        ? (
                                                              (banners[0] || {})
                                                                  .image || {}
                                                          ).large
                                                        : null
                                                })`
                                            }}
                                        >
                                            <div className="container">
                                                <div className="row">
                                                    <div className="inn-pag-ban">
                                                        <h2>
                                                            <FormattedMessage
                                                                id={data.title}
                                                                defaultMessage={
                                                                    data.title
                                                                }
                                                            />
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="p-about com-padd">
                                            <div
                                                className="container"
                                                style={{ textAlign: 'left' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: data.description
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <AppLinks settings={this.props.settings} />
            </HOCLoader>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings: settings };
};
const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(injectIntl(Detail));



// WEBPACK FOOTER //
// ./src/views/Page/Detail.jsx